import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { API, authHeaders } from "@/lib/api";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Mail } from "lucide-react";
import { toast } from "sonner";

const STATUSES = ["NEW", "CONTACTED", "QUOTATION SENT", "NEGOTIATION", "SAMPLE REQUESTED", "ORDER CONFIRMED", "CLOSED", "LOST"];

const AdminContacts = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = () => {
    axios.get(`${API}/enquiries`, authHeaders())
      .then((r) => setRows(r.data.filter((e) => e.source === "contact-page")))
      .catch(() => toast.error("Could not load contact leads"))
      .finally(() => setLoading(false));
  };
  useEffect(load, []);

  const setStatus = async (id, status) => {
    try {
      await axios.patch(`${API}/admin/enquiries/${id}/status`, { status }, authHeaders());
      setRows((rs) => rs.map((r) => (r.id === id ? { ...r, status } : r)));
      toast.success(`Status → ${status}`);
    } catch (e) { toast.error("Status update failed"); }
  };

  if (loading) return <div className="text-[#171717]/60 text-sm">Loading contact leads…</div>;

  return (
    <div data-testid="admin-contacts">
      <div className="font-display text-xl text-[#004225] mb-4">Contact Leads ({rows.length})</div>
      {rows.length === 0 && (
        <div className="bg-white border border-[#004225]/10 rounded-sm p-10 text-center text-[#171717]/60">
          <Mail className="h-6 w-6 mx-auto text-[#B5942D] mb-2" />No general contact enquiries yet. Email leads continue to arrive at gnagrotraders@gmail.com.
        </div>
      )}
      <div className="space-y-2">
        {rows.map((e) => (
          <div key={e.id} className="bg-white border border-[#004225]/10 rounded-sm p-4 flex flex-wrap items-center gap-3" data-testid={`contact-lead-${e.id}`}>
            <div className="text-[11px] text-[#171717]/50 w-24">{(e.created_at || "").slice(0, 10)}</div>
            <div className="flex-1 min-w-[180px]">
              <div className="font-semibold text-[#004225] text-sm">{e.name} — {e.company}</div>
              <div className="text-[12px] text-[#171717]/60">{e.country} · {e.email} · {e.phone}</div>
              {e.message && <div className="text-[12px] text-[#171717]/70 mt-1 line-clamp-2">{e.message}</div>}
            </div>
            <Link to={`/admin/enquiries/${e.id}`} data-testid={`open-lead-${e.id}`} className="text-[11px] font-semibold uppercase tracking-widest text-[#004225] border border-[#004225]/20 rounded-full px-3 py-1.5 hover:bg-[#F7F2E2]">Profile</Link>
            <Select value={(e.status || "NEW").toUpperCase()} onValueChange={(v) => setStatus(e.id, v)}>
              <SelectTrigger className="w-44"><SelectValue /></SelectTrigger>
              <SelectContent>{STATUSES.map((s) => (<SelectItem key={s} value={s}>{s}</SelectItem>))}</SelectContent>
            </Select>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdminContacts;
